function dateFormat(dateObject, format) {
    let _format = format;
    const date = {
      "M+": dateObject.getMonth() + 1,
      "d+": dateObject.getDate(),
      "H+": dateObject.getHours(),
      "h+": dateObject.getHours() <= 12 ? dateObject.getHours() : dateObject.getHours() - 12,
      "m+": dateObject.getMinutes(),
      "s+": dateObject.getSeconds(),
      "q+": Math.floor((dateObject.getMonth() + 3) / 3),
      "S+": dateObject.getMilliseconds()
    };
    if (/(y+)/i.test(_format)) {
      _format = _format.replace(RegExp.$1, (dateObject.getFullYear() + '').substr(4 - RegExp.$1.length));
    }
    for (const k in date) {
      if (new RegExp("(" + k + ")").test(_format)) {
        _format = _format.replace(RegExp.$1, RegExp.$1.length === 1
          ? date[k] : ("00" + date[k]).substr(("" + date[k]).length));
      }
    }
    return _format;
  }
  
  function dateFormatter(str){  // 默认返回yyyy-MM-dd HH-mm-ss
      let hasTime = arguments[1] != false ? true : false; // 可以传第二个参数false,返回yyyy-MM-dd
      let d = new Date(str);
      let year = d.getFullYear();
      let month = (d.getMonth()+1) < 10 ? '0' + (d.getMonth()+1) : (d.getMonth() + 1);
      let day = d.getDate() < 10 ? '0' + d.getDate() : d.getDate();
      let hour = d.getHours() < 10 ? '0'+ d.getHours() : d.getHours();
      let minute = d.getMinutes() < 10 ? '0' +d.getMinutes() : d.getMinutes();
      let second = d.getSeconds() < 10 ? '0' +d.getSeconds() : d.getSeconds();
      if(hasTime){  // 如果传入的第二个参数是true,则返回:yyyy-MM-dd HH:mm:ss
          return [year, month, day].join('-') + " " + [hour, minute, second].join(':');
      }else{  // 如果传入的第二个参数是false或者不传入，则返回:yyyy-MM-dd
          return [year, month, day].join('-');
      }
  }
  
  function formatDuring(mss) {
      let time = mss;
      if (null != time && "" != time) {
          if (time > 60 && time < 60 * 60) {
              time = parseInt(time / 60.0) + "分" + parseInt((parseFloat(time / 60.0) -
                  parseInt(time / 60.0)) * 60) + "秒";
          }
          else if (time >= 60 * 60 && time < 60 * 60 * 24) {
              time = parseInt(time / 3600.0) + "小时" + parseInt((parseFloat(time / 3600.0) -
                  parseInt(time / 3600.0)) * 60) + "分" +
                  parseInt((parseFloat((parseFloat(time / 3600.0) - parseInt(time / 3600.0)) * 60) -
                  parseInt((parseFloat(time / 3600.0) - parseInt(time / 3600.0)) * 60)) * 60) + "秒";
          } else if (time >= 60 * 60 * 24) {
              time = parseInt(time / 3600.0/24) + "天" +parseInt((parseFloat(time / 3600.0/24)-
                  parseInt(time / 3600.0/24))*24) + "小时" + parseInt((parseFloat(time / 3600.0) -
                  parseInt(time / 3600.0)) * 60) + "分" +
                  parseInt((parseFloat((parseFloat(time / 3600.0) - parseInt(time / 3600.0)) * 60) -
                  parseInt((parseFloat(time / 3600.0) - parseInt(time / 3600.0)) * 60)) * 60) + "秒";
          }
          else {
              time = parseInt(time) + "秒";
          }
      }
      return time;
  }

  /**
   * 根据出生日期算出年龄
   */
  function getAge(birthday) {
      var age;
      var strBirthdayArr = strBirthdayArr.split("-");
      var birthYear = strBirthdayArr[0];
      var birthMonth = strBirthdayArr[1];
      var birthDay = strBirthdayArr[2]; 

      d = new Date();
      var nowYear = d.getFullYear();
      var nowMonth = d.getMonth() + 1;
      var nowDay = d.getDate();

      if(nowYear == birthYear) {
          age = 0;  // 同年，记为0岁
      } else {
          var ageDiff = nowYear - birthDay;  // 年之差
          if(ageDiff > 0) {
              if(nowMonth == birthMonth){
                  var dayDiff = nowDay - birthDay;  // 日之差
                  if(dayDiff < 0) {
                      age = ageDiff - 1;
                  }else{
                      age = ageDiff;
                  }
              }else{
                  var monthDiff = nowMonth - birthMonth;  // 月之差
                  if(monthDiff < 0){
                      age = ageDiff - 1
                  }else{
                      age = ageDiff
                  }
              }
          }
      }
      return age;   // 返回周岁年龄
  }
  
  const time = {
      timestampToTime(ts) {
        let date = new Date();
        date.setTime(ts);
        return date;
      },
      dateFormat(dateObj, format) {
        return dateFormat(dateObj, format);
      },
      timestampToFormat(ts, format) {
        const t = new Date();
        t.setTime(ts);
        return dateFormat(t, format);
      },
      dateFormatter(str) {
          return dateFormatter(str);
      },
      formatDuring(mss) {
          return formatDuring(mss);
      },
      getAge(ts) {
          return getAge(ts)
      }
    };
  
    export default time;
    export function timestampFormat( timestamp  ) {
      function zeroize( num ) {
          return (String(num).length == 1 ? '0' : '') + num;
      }
      timestamp = timestamp / 1000;
      var curTimestamp = parseInt(new Date().getTime() / 1000); //当前时间戳
      var timestampDiff = curTimestamp - timestamp; // 参数时间戳与当前时间戳相差秒数
   
      var curDate = new Date( curTimestamp * 1000 ); // 当前时间日期对象
      var tmDate = new Date( timestamp * 1000 );  // 参数时间戳转换成的日期对象
   
      var Y = tmDate.getFullYear(), m = tmDate.getMonth() + 1, d = tmDate.getDate();
      var H = tmDate.getHours(), i = tmDate.getMinutes(), s = tmDate.getSeconds();
   
      if ( timestampDiff < 60 ) { // 一分钟以内
          return "刚刚";
      } else if( timestampDiff < 3600 ) { // 一小时前之内
          return Math.floor( timestampDiff / 60 ) + "分钟前";
      } else if ( curDate.getFullYear() == Y && curDate.getMonth()+1 == m && curDate.getDate() == d ) {
          return '今天' + zeroize(H) + ':' + zeroize(i);
      } else {
          var newDate = new Date( (curTimestamp - 86400) * 1000 ); // 参数中的时间戳加一天转换成的日期对象
          if ( newDate.getFullYear() == Y && newDate.getMonth()+1 == m && newDate.getDate() == d ) {
              return '昨天' + zeroize(H) + ':' + zeroize(i);
          } else if ( curDate.getFullYear() == Y ) {
              return  zeroize(m) + '月' + zeroize(d) + '日 ' + zeroize(H) + ':' + zeroize(i);
          } else {
              return  Y + '年' + zeroize(m) + '月' + zeroize(d) + '日 ' + zeroize(H) + ':' + zeroize(i);
          }
      }
  }


// WEBPACK FOOTER //
// ./src/utils/time.js